import {Component, OnInit} from '@angular/core';
import {ImageUrls} from '../../../shared/constants/ImageUrls';
import {RouteUrls} from '../../../shared/constants/RouteUrls';
import {PermissionLink} from '../../../shared/permission/PermissionLink';
import {Actions, ApiEndpoints} from '../../../shared/constants/ApiEndpoints';
import {TokenService} from '../../../shared/services/token.service';
import {RequestMethod, RestService} from '../../../shared/services/rest.service';
import {MatDialog} from '@angular/material/dialog';
import {roles} from '../../../shared/enums/res/roles';
import {MyProfileComponent} from '../my-profile/my-profile.component';
import {Partner} from '../../../shared/models/res/partner';
import {NotificationsComponent} from '../notifications/notifications/notifications.component';
import {WebSocketService} from '../../../shared/services/web-socket.service';
import {CookieUtils} from '../../../shared/utils/CookieUtils';
import {GeneralConstant} from '../../../shared/constants/GeneralConstant';
import {UserService} from '../../../shared/services/user.service';
import {ConfirmModalComponent} from '../../shared/modules/confirm-modal/confirm-modal.component';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-header-logged',
  templateUrl: './header-logged.component.html',
  styleUrls: ['./header-logged.component.scss']
})
export class HeaderLoggedComponent implements OnInit {
  user: Partner = new Partner();

  logo = ImageUrls.LOGO_WHITE;
  avatar = ImageUrls.AVATAR;
  bell = ImageUrls.BELL;
  logoutPath = '/' + RouteUrls.LOGOUT;
  usersLink = '/' + RouteUrls.ACCOUNT_SETTINGS.MODULE_BASE;
  applicationList = '/application';
  facilityInformationLink = '/facility';
  surveyLink = '/' + RouteUrls.SURVEY.MODULE_BASE;
  investigationLink = '/' + RouteUrls.INVESTIGATION.MODULE_BASE;
  customerLink = '/' + RouteUrls.FINANCIAL.FACILITIES_LIST.MODULE_BASE;
  accreditationLink = '/' + RouteUrls.ACCREDITATION.MODULE_BASE;
  externalReportsLink = '/' + RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT;
  qboConnected = true;

  // permission links to check
  userPermission = PermissionLink.appendLink(ApiEndpoints.RES.USER, Actions.BASE_ACTIONS.READ);
  invoicePermission = PermissionLink.appendLink(ApiEndpoints.ACCOUNT.INVOICE, Actions.BASE_ACTIONS.READ);
  paymentPermission = PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.READ);
  orderPermission = PermissionLink.appendLink(ApiEndpoints.ACCOUNT.SALE_ORDER, Actions.BASE_ACTIONS.READ);
  qboPermission = PermissionLink.appendLink(ApiEndpoints.ACCOUNT.QBO, 'connect');
  applicationCustomReadListPermission = PermissionLink.appendLink(ApiEndpoints.ACCR.APPLICATION, Actions.ACCREDITATION.CUSTOM_READ);
  applicationListPermission = PermissionLink.appendLink(ApiEndpoints.ACCR.APPLICATION, Actions.BASE_ACTIONS.READ);
  investigationPermission = PermissionLink.appendLink(ApiEndpoints.INVESTIGATION.INVESTIGATION, Actions.BASE_ACTIONS.READ);
  facilityListPermission = PermissionLink.appendLink(ApiEndpoints.RES.FACILITY, Actions.BASE_ACTIONS.FETCH);
  surveyPermission = PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ);
  accreditationPermission = PermissionLink.appendLink(ApiEndpoints.ACCR.ACCREDITATION, Actions.BASE_ACTIONS.READ);
  externalReportsPermission = PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ);
  historyPermission = PermissionLink.appendLink(ApiEndpoints.HISTORY.HISTORY, Actions.BASE_ACTIONS.READ);
  notificationCount = 0;

  constructor(
    private tokenService: TokenService,
    private restService: RestService,
    private dialog: MatDialog,
    private stomp: WebSocketService,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    this.checkForNewRelease();
    this.stomp.connect();
    this.stomp.stompClient.onConnect = () => {
      this.stomp.stompClient.subscribe('/notification/count', (message): any => {
        if (this.tokenService.getUserFromToken().username === message.body) {
          if (!this.userService.getUserUUID()) {
            CookieUtils.removeCookie(GeneralConstant.TOKEN);
            CookieUtils.removeCookie(GeneralConstant.REFRESH_TOKEN);
            localStorage.clear();
            location.reload();
          }
        } else {
          this.getNewNotificationsCount();
        }
      });
      this.stomp.stompClient.subscribe('/notification/session_expired', (message): any => {
        if (this.tokenService.getUserFromToken().id === message.body) {
          this.dialog.open(ConfirmModalComponent, {
            data: {
              fullName: 'The session has already expired.',
              name: '',
              type: 'OK',
              removeQuestionMark: true,
              content: 'The session has already expired.'
            }
          });
          CookieUtils.removeCookie(GeneralConstant.TOKEN);
          CookieUtils.removeCookie(GeneralConstant.REFRESH_TOKEN);
          localStorage.clear();
          location.reload();
        }
      });
    };
    this.getMyProfile();
    this.tokenService.getRolesFromToken().forEach(item => {
      if (item === roles.GLOBAL_ADMIN.name || item === roles.ADMIN.name || item === roles.FINANCE_DIRECTOR.name) {
        this.getQboConnected();
      }
    });
    this.getNewNotificationsCount();
  }

  myProfile() {
    const dialogRef = this.dialog.open(MyProfileComponent, {
      data: {},
      panelClass: 'my-profile-modal-wrap'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getMyProfile();
    });
  }

  myNotifications() {
    const dialogRef = this.dialog.open(NotificationsComponent, {
      data: {},
      panelClass: 'notifications-list'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.notificationCount = 0;
    });
  }

  getMyProfile() {
    if (this.tokenService.getUserFromToken()) {
      this.restService.request<any>(
        RequestMethod.GET,
        ApiEndpoints.RES.PARTNER,
        'read-profile' + '/' + this.tokenService.getUserFromToken().contact.id
      ).subscribe(response => {
        if (response.success) {
          this.user = response.data;
          this.avatar = this.user && this.user.logo ? this.user.logo.filePath : ImageUrls.AVATAR;
        }
      });
    }
  }

  getQboConnected() {
    this.restService.request<any>(
      RequestMethod.GET,
      ApiEndpoints.ACCOUNT.QBO,
      `read/authenticated`
    ).subscribe(response => {
      this.qboConnected = response.data;
    });
  }

  connectToQbo() {
    this.restService.request<any>(
      RequestMethod.GET,
      ApiEndpoints.ACCOUNT.QBO,
      `connect`
    ).subscribe(response => {
      window.location.replace(response.data.url);
    });
  }

  getNewNotificationsCount() {
    this.restService.request<any>(
      RequestMethod.GET,
      ApiEndpoints.NOTIFICATION.NOTIFICATION,
      `read/count`,
      {
        params: {
          partnerId: this.tokenService.getUserFromToken().contact.id
        }
      }
    ).subscribe(response => {
      this.notificationCount = response.data;
    });
  }
  // Add method to check for new releases and clear cookies
  checkForNewRelease() {
    // Fetch dynamic release version from an environment file or global variable
    const currentVersion = environment.version || this.getVersionFromEnvFile();

    const previousVersion = localStorage.getItem('releaseVersion');

    if (previousVersion != null && previousVersion !== currentVersion) {
      this.clearCookies();
      localStorage.setItem('releaseVersion', currentVersion);
    } else {
      localStorage.setItem('releaseVersion', currentVersion);
    }
  }

  getVersionFromEnvFile() {
    try {
      const envContent = require('fs').readFileSync('/path/to/version.env', 'utf-8');
      const match = envContent.match(/CURRENT_RELEASE_VERSION=(.*)/);
      return match ? match[1] : 'unknown';
    } catch (e) {
      console.error('Failed to read version from file', e);
      return 'unknown';
    }
  }


  // Method to clear cookies
  clearCookies() {
    const cookies = document.cookie.split(';');

    cookies.forEach(cookie => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
    window.location.reload();
  }
}
